module.exports = __webpack_public_path__ + "static/media/netstorage/fonts/gotham_medium.woff2";